import { cardsData } from '@/mocks/homeData';

export default function CardsSection() {
  const scrollTo = (id: string) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">热门综艺精选</h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">精选全网最受欢迎的综艺节目，搞笑、竞技、美食、音乐，总有一款适合你</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cardsData.map((card) => (
            <article key={card.id} className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden transition-all duration-300 hover:border-primary-200 cursor-pointer">
              <div className="relative w-full aspect-[16/10] overflow-hidden bg-background-100">
                <img
                  src={card.image}
                  alt={card.title}
                  title={`${card.title} - 香蕉影视`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-3 py-1 bg-primary-500/90 text-background-50 text-xs font-medium rounded-full whitespace-nowrap">{card.tag}</span>
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-4">
                  <button
                    onClick={(e) => { e.stopPropagation(); scrollTo('#media'); }}
                    className="w-full py-2 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium rounded-lg transition-colors whitespace-nowrap cursor-pointer text-center"
                  >
                    <i className="ri-play-fill mr-1"></i>立即观看
                  </button>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-lg font-bold text-foreground-900 mb-2">{card.title}</h3>
                <p className="text-foreground-600 text-sm leading-relaxed">{card.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}